export default __webpack_public_path__ + "_/shared_modules/common-images/left-arrow-846654e51a4c29e97b971ff514c1deda.svg";